import { action } from 'typesafe-actions';
import { IProdutos, ProdutosTypes } from './types';

export const loadRequestProdutos = (inscricaoAtiva: any,
  cddAtivo: number | undefined) => action(ProdutosTypes.LOAD_REQUEST, 
    { inscricaoAtiva, cddAtivo });
export const loadSuccess = (data: IProdutos[]) =>
  action(ProdutosTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(ProdutosTypes.LOAD_FAILURE);

export const cleanStateProdutos = () => action(ProdutosTypes.CLEAN_PRODUTOS);
